<template>
  <div class="is-flex is-justify-content-space-between">
    <div class="sticky" style="min-width: 600px; top: 0; overflow-y: auto;">
      <internal-notes :payload="payload.data" :additional_data="{ resource_type: payload.resource_type }" :is_modal="false" :eager_load="true">
      </internal-notes>
    </div>
    <div class="horizontal_space"></div>
    <div class="horizontal_space"></div>
    <div class="horizontal_space"></div>
    <div class="full_width">
      <div v-if="payload.resource_type == 'Applicant'" class="is-flex is-align-items-center is-justify-content-space-between">
        <div class="is-flex is-align-items-center is-justify-content-flex-end">
          <a @click="openSkills" class="button is-outlined is-info">Skills</a>
          <div class="horizontal_space"></div>
          <button @click="hotPositions" class="button is-outlined is-warning">Offers</button>
        </div>
        <div>
          <message :payload="payload.data" :additional_data="{ resource_type: 'Applicant', endpoint: '/users/', headers: 'admin_headers' }"></message>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div class="relative is-flex is-justify-content-center is-justify-content-space-between">
        <div>
          <a class="button is-outlined is-info" @click="addItem()">Add Item</a>
        </div>
        <div class="is-flex is-align-items-center">
          <a v-if="!show_timing_form" @click="showTimingForm" dir="rtl" class="button is-info">קבע מועד חדש ל- Follow Up</a>
          <div v-else class="is-flex is-flex-direction-column">
            <snooze v-model="selected_timing" :selected_date="selected_timing"></snooze>
            <a @click="changeTiming()" class="button is-info timing_submit_button" :class="{ 'is-loading': is_changing_timing }">
              Submit
            </a>
          </div>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div class="is-flex is-flex-direction-row-reverse">
        <div>
          <a @click="doneAllAlert" class="button is-info is-outlined">Done All</a>
        </div>
      </div>
      <div dir="ltr" class="is-flex is-justify-content-center" style="margin-top: 30px;">
        <div v-if="is_loading" class="loading"></div>
        <p v-if="!is_loading && alerts.length == 0">NO ALERTS.</p>
      </div>
      <div v-for="alert in alerts" :key="alert.id" class="alert_container" :style="{ 'border-color': getAlertBorderColor(alert) }">
        <div>
          <div class="is-flex is-align-items-center is-justify-content-flex-end">
            <div class="horizontal_space"></div>
            <a @click="editAlert(alert)" class="button is-info is-outlined">Edit</a>
            <div class="horizontal_space"></div>
            <a @click="doneAlert(alert)" class="button is-info is-outlined">{{ alert.doneText }}</a>
            <div v-if="alert.resource_type == 'Offer'" class="is-flex">
              <div class="horizontal_space"></div>
              <img @click="openRelatedPositions(alert)" class="btn" src="/group.svg" width="30px">
            </div>
          </div>
          <div class="is-flex is-justify-content-space-between" style="color: #999; text-align: left;">
            <div>
              <p v-if="alert.owner" class="m-0 text_align_right">{{alert.owner}}</p>
              <p class="m-0"><b>designator:</b> {{alert.designator}}</p>
            </div>
            <div class="is-flex">
              <div dir="ltr" class="is-flex is-flex-direction-column">
                <p class="m-0"><b>Timing: </b>{{time_helper.makeTimeReadable(alert.timing)}}</p>
                <p class="m-0"><b>Priority:</b> {{alert.priority}}</p>
              </div>
            </div>
          </div>
          <p><b>{{alert.title}}</b></p>
        </div>
        <div dir="ltr">
          <div class="is-flex is-justify-content-flex-end">
            <FeedContent :alert="alert" />
          </div>
          <div class="mt-2">
            <FeedAlertResources v-if="!showResourceWrapper(alert)" :alert="alert" />
          </div>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import FeedContent from '@/components/FeedContent'
import FeedAlertResources from '@/components/FeedAlertResources'
import InternalNotes from '@/components/InternalNotes'
import Snooze from '@/components/Snooze'
import Message from '@/components/Message'
export default {
  name: 'resource-alerts-form',
  components: {
    FeedContent,
    InternalNotes,
    Snooze,
    Message,
    FeedAlertResources
  },
  props: ['payload'],
  data () {
    return {
      alerts: [],
      time_helper: new TimeHelper(),
      is_loading: true,
      show_timing_form: false,
      is_changing_timing: false,
      selected_timing: undefined
    }
  },
  created () {
    this.getAlerts()
  },
  methods: {
    openRelatedPositions (alert) {
      this.create({
        designator: 'related-positions-modal',
        component_name: 'RelatedPositions',
        position: alert.resources.position,
        applicant: alert.resources.applicant,
        modal_title: alert.resources.position.title + ' - ' + alert.resources.position.company.name + ' - Related Positions '
      })
    },
    editAlert (alert) {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        data: alert,
        resource_type: this.payload.resource_type,
        resource_id: this.getResourceId(),
        modal_title: 'Designator: ' + alert.designator + ', Title: ' + alert.title
      })
    },
    doneAllAlert () {
      if (confirm('האם את/ה בטוח/ה שתרצה לסיים את התהליכים למועמד/ת?')) {
        this.alerts.forEach(alert => {
          this.doneAlert(alert)
        })
      }
    },
    showResourceWrapper (alert) {
      return ['send_cv'].includes(alert.designator)
    },
    doneAlert (data) {
      let status = ''
      if (data.doneText == 'Done') {
        status = 'done'
        data.doneText = 'UnDone'
      } else {
        status = 'active'
        data.doneText = 'Done'
      }
      this.$network_utils.postDoneAlert(data, status)
    },
    addItem () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        resource_type: this.payload.resource_type,
        resource_id: this.getResourceId(),
        modal_title: 'Create new Item'
      })
    },
    getResourceId () {
      return ['Offer', 'Position'].includes(this.payload.resource_type) ? this.payload.data.id : this.payload.data.resource_id
    },
    getAlerts () {
      this.$network_utils.getResourceAlerts({ current_resource_type: this.payload.resource_type, current_resource_id: this.getResourceId(), statuses: 'active,in_progress', sort: '-timing' }).then(response => {
        this.is_loading = false
        this.alerts = response.map(alert => ({ ...alert, doneText: 'Done' }))
      })
    },
    showTimingForm () {
      this.show_timing_form = true
    },
    async changeTiming () {
      if (this.selected_timing == undefined) {
        this.$utils.emit('show_toast', { text: 'תאריך לא בחור' })
        return
      }
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: 'internal_notes',
        content: `All Alerts Changed Timing To <b>${new Date(this.selected_timing).toLocaleString()}</b>`,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 4,
        resource_type: this.payload.resource_type,
        resource_id: this.getResourceId()
      })
      let requests = []
      this.alerts.forEach(alert => {
        requests.push(this.$network_utils.updateAlert({ id: alert.id, timing: this.selected_timing }))
      })
      const applicantAlerts = await this.$network_utils.getAllAlerts({ owner: this.$utils.getOwner().name, statuses: 'in_progress' })
      applicantAlerts.forEach(alert => {
        requests.push(this.$network_utils.updateAlert({ id: alert.id, status: 'active', owner: 'NULL' }))
      })
      this.is_changing_timing = true
      this.$caller.axios.all(requests).then(() => {
        this.is_changing_timing = false
        this.$utils.emit('show_toast', { text: 'שונה בהצלחה' })
      })
    },
    hotPositions () {
      this.create({
        designator: 'hot-positions-modal',
        component_name: 'GhanaFlagForm',
        modal_title: 'Hot Positions',
        resource_type: 'Applicant',
        resource_id: this.getResourceId(),
        statuses: 'awaiting_applicant,awaiting_admin,awaiting_applicant_strong,system_strong,awaiting_company,filtered_out',
        isHotPositions: true,
        modal_width: 1000
      })
    },
    openSkills () {
      this.create({
        designator: 'applicant-skill-form-modal',
        component_name: 'ApplicantSkillsForm',
        data: { resource_id: this.getResourceId() },
        modal_title: 'Skills',
        modal_width: 1300,
        is_center_modal: true
      })
    },
    getAlertBorderColor (alert) {
      let timing = new Date(alert.timing)
      let is_future = timing.getTime() > new Date().getTime()
      return is_future ? 'orange' : 'green'
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
<style>
  .alert_container{
    width: 100%;
    border-radius: 4px;
    margin-top: 10px;
    padding: 12px;
    border-style: solid;
    border-width: 2px;
    background-color: rgba(0, 0, 0, 0.07);
  }
  .alert_title{
    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
    padding-bottom: 10px;
  }
  .timing_submit_button{
    margin-top: 20px;
  }
</style>
